"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleError = exports.errorMessage = exports.successMessage = exports.classFromVariant = exports.getDate = exports.getDirection = exports.getLabel = exports.t = exports.getLangcode = exports.currentLanguage = exports.getFormattedExtension = exports.toMB = exports.getFieldArrayErrors = exports.getError = exports.validateFile = exports.isSectionRequired = exports.isRequired = void 0;
var constants_1 = require("./constants");
// start translation copy
var forEach_1 = __importDefault(require("lodash/forEach"));
var ar_json_1 = __importDefault(require("./locales/ar.json"));
var en_json_1 = __importDefault(require("./locales/en.json"));
var classnames_1 = __importDefault(require("classnames"));
var react_toastify_1 = require("react-toastify");
var axios_1 = require("axios");
// end translation copt
// this file is only for data related utils
// any data fetching or ui logic should be in the components
function isRequired(name, required) {
    if (!required)
        return { value: false, message: "" };
    return (required === null || required === void 0 ? void 0 : required[name]) ? constants_1.REQUIRED : { value: false, message: "" };
}
exports.isRequired = isRequired;
function isSectionRequired(name, required) {
    return (required === null || required === void 0 ? void 0 : required[name])
        ? true
        : false;
}
exports.isSectionRequired = isSectionRequired;
function checkFileExtension(file, fileType, formatedExtionsions) {
    if (fileType === void 0) { fileType = "photo"; }
    var allowedExtensions = (formatedExtionsions === null || formatedExtionsions === void 0 ? void 0 : formatedExtionsions.length) && (formatedExtionsions === null || formatedExtionsions === void 0 ? void 0 : formatedExtionsions.length) > 0
        ? formatedExtionsions
        : fileType === "photo"
            ? constants_1.IMAGE_FILES
            : constants_1.DOC_FILES;
    var fileExtension = file.name.split(".").pop();
    if (!fileExtension)
        return false;
    return allowedExtensions.includes(fileExtension);
}
function validateFile(value, name, requiredFields, max_upload_size, fileType, allowedExtensions) {
    if (fileType === void 0) { fileType = "photo"; }
    if (!requiredFields || !max_upload_size)
        return true;
    var formatedExtionsions = getFormattedExtension(allowedExtensions);
    if (value && value[0] && value[0].size > max_upload_size) {
        return (0, exports.t)("file must be smaller than") + " ".concat(toMB(max_upload_size));
    }
    if (value &&
        value[0] &&
        value[0].name &&
        !checkFileExtension(value[0], fileType, formatedExtionsions)) {
        return "invalid file extension";
    }
    return true;
}
exports.validateFile = validateFile;
function getError(errors, name) {
    var error = errors === null || errors === void 0 ? void 0 : errors["".concat(name.includes(".") ? name.split(".").at(-1) : name)];
    if (error && typeof (error === null || error === void 0 ? void 0 : error.message) === "string" && error.message !== "") {
        return { value: true, message: error.message };
    }
    else if ((error === null || error === void 0 ? void 0 : error.type) === "required") {
        return { value: true, message: constants_1.REQUIRED.message };
    }
    return { value: false, message: "" };
}
exports.getError = getError;
function getFieldArrayErrors(fieldIndex, fieldErrors) {
    if (fieldErrors && Array.isArray(fieldErrors)) {
        return fieldErrors.at(fieldIndex);
    }
    return false;
}
exports.getFieldArrayErrors = getFieldArrayErrors;
function toMB(bytes) {
    if (!bytes)
        return "";
    return (bytes / 1024 / 1024).toFixed(2).slice(0, -1) + " MB";
}
exports.toMB = toMB;
function getFormattedExtension(allowedFileTypes) {
    if (!allowedFileTypes)
        return "";
    return allowedFileTypes
        .split(" ")
        .map(function (ext) { return (ext.charAt(0) === "." ? ext : "." + ext); })
        .join(" ,");
}
exports.getFormattedExtension = getFormattedExtension;
exports.currentLanguage = {
    langcode: "ar",
    dir: "rtl",
};
var getLangcode = function () {
    var _a;
    if (typeof window === "undefined") {
        return exports.currentLanguage.langcode;
    }
    else
        return (((_a = document.getElementsByTagName("html")[0]) === null || _a === void 0 ? void 0 : _a.getAttribute("lang")) || "ar");
};
exports.getLangcode = getLangcode;
var t = function (text, params) {
    var lang = (0, exports.getLangcode)();
    var json = (lang === "ar" ? ar_json_1.default : en_json_1.default);
    var translated = json[text] || text;
    if (params) {
        (0, forEach_1.default)(params, function (value, key) {
            translated = translated.replace("{{".concat(key, "}}"), value.toString());
        });
    }
    return translated;
};
exports.t = t;
// Returns the label overridden from the portal settings, or the translated
// default label.
var getLabel = function (name, fallback, labels) { return (labels === null || labels === void 0 ? void 0 : labels[name]) || (0, exports.t)(fallback); };
exports.getLabel = getLabel;
var getDirection = function () {
    var _a;
    if (typeof window === "undefined") {
        return exports.currentLanguage.dir;
    }
    else
        return (((_a = document.getElementsByTagName("html")[0]) === null || _a === void 0 ? void 0 : _a.getAttribute("dir")) || "ltr");
};
exports.getDirection = getDirection;
// end copy of the t translator
function getDate(DateObject) {
    if (DateObject && DateObject.length > 0) {
        DateObject = DateObject.map(function (item) {
            return __assign(__assign({}, item), { date_range: {
                    from: (item === null || item === void 0 ? void 0 : item.date_range.from)
                        ? new Date(item === null || item === void 0 ? void 0 : item.date_range.from).getTime()
                        : undefined,
                    to: (item === null || item === void 0 ? void 0 : item.date_range.to)
                        ? new Date(item === null || item === void 0 ? void 0 : item.date_range.to).getTime()
                        : undefined,
                } });
        });
    }
    return DateObject;
}
exports.getDate = getDate;
function classFromVariant(variant) {
    if (variant === void 0) { variant = "md"; }
    if (variant === "sm") {
        return "md:w-fi-sm flex-shrink-0";
    }
    else if (variant === "md") {
        return "md:w-fi-md flex-shrink-0";
    }
    else {
        return "md:w-fi-lg flex-shrink-0";
    }
}
exports.classFromVariant = classFromVariant;
var successMessage = function (message, options) {
    var _a;
    if (options === void 0) { options = {}; }
    var toastClassName = (0, classnames_1.default)(((_a = options === null || options === void 0 ? void 0 : options.className) === null || _a === void 0 ? void 0 : _a.toString()) || "", "toast-wrapper");
    delete options.className;
    console.log("toasting");
    react_toastify_1.toast.success(message, __assign({ rtl: document.documentElement.lang === "ar", position: document.documentElement.lang === "ar" ? "top-left" : "top-right", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: false, draggable: false, progress: undefined, progressClassName: "toast-progress", className: toastClassName }, options));
};
exports.successMessage = successMessage;
var errorMessage = function (error, options) {
    var _a;
    if (options === void 0) { options = {}; }
    var toastClassName = (0, classnames_1.default)(((_a = options === null || options === void 0 ? void 0 : options.className) === null || _a === void 0 ? void 0 : _a.toString()) || "", "toast-wrapper");
    delete options.className;
    react_toastify_1.toast.error(error, __assign({ rtl: document.documentElement.lang === "ar", position: document.documentElement.lang === "ar" ? "top-left" : "top-right", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: false, draggable: false, progress: undefined, progressClassName: "toast-progress", className: toastClassName }, options));
};
exports.errorMessage = errorMessage;
var handleError = function (error) {
    var _a, _b, _c, _d;
    // TODO: Handle messages.
    if (error instanceof axios_1.AxiosError) {
        if (((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 403) {
            return (0, exports.errorMessage)("Permission denied");
        }
        return (0, exports.errorMessage)((_d = (_c = (_b = error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) !== null && _d !== void 0 ? _d : error.message);
    }
    (0, exports.errorMessage)("Unexpected error happened: ".concat(error));
    return;
};
exports.handleError = handleError;
